import { makeStyles } from 'tss-react/mui';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles()((theme) => ({
  table: {
    minWidth: 650,
  },
  tableRow: {
    cursor: 'pointer',
  },
  formControl: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  formLabel: {
    marginTop: theme.spacing(3),
  },
  evaluateButton: {
    marginLeft: theme.spacing(4),
  },
}));
